<template>
  <section class="events-cards">
    <div class="list-container">
      <div class="grid">
        <router-link
          v-for="(item, index) in data"
          tag="a"
          :to="$store.getters['main/getSingleUrl'](item)"
          class="event-info fade-up"
          v-in-viewport.once
          :key="index"
        >
          <h3 class="font-21 text-overflow-hidden-2">
            {{ item[`title_${$store.state.main.locale}`] }}
          </h3>
          <!-- <div
						class="text-overflow-hidden-2-envent event-text"
						v-html="item[`content_${$store.state.main.locale}`]"
					></div> -->
          <div class="publish-date">
            {{ $fn.tr('Published:') }} {{ item.date | moment('DD/M/YYYY') }}
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ['data'],
};
</script>
<style lang="scss">
.events-cards {
  //   h2 {
  //     text-decoration: underline;
  //     text-decoration-color: var(--red);
  //     margin-bottom: 55px;
  //     width: fit-content;
  //     color: var(--bonus-txt);
  //   }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 55px;
    column-gap: 30px;
    @media (max-width: 1365px) {
      row-gap: 34px;
      column-gap: 35px;
    }
    @media (max-width: 1023px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      row-gap: 55px;
    }
    .event-info {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .img-box {
        position: relative;
        padding-top: 53%;
        .img-absolute {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      h3 {
        margin-bottom: 17px;
        line-height: 28px;
        color: var(--bonus-txt);
        text-decoration: underline;
        text-decoration-color: var(--bonus-txt);
        @media (max-width: 1365px) {
          margin: 21px 0;
          line-height: 31px;
          font-size: 21px;
        }
        @media (max-width: 1023px) {
          margin: 34px 0;
          line-height: 41px;
          font-size: 34px;
        }
        @media (max-width: 767px) {
          margin: 21px 0;
          line-height: 31px;
          font-size: 21px;
        }
      }
      .event-text {
        color: var(--bonus-txt);
        text-decoration: underline;
        text-decoration-color: var(--bonus-txt);
        line-height: 24px;
        max-height: 48px;
        overflow: hidden;
        p {
          font-size: 16px !important;
        }
      }
      .publish-date {
        margin-top: 10px;
        color: #db504a;
        overflow: hidden;
        line-height: 24px;
        padding-bottom: 34px;
        font-size: 16px !important;
        border-bottom: 1px solid #db504a;
      }
    }
  }
}
</style>
